// extracted by mini-css-extract-plugin
export default {"signDocItem":"SignDocItem_signDocItem__dfEdm","checkIcon":"SignDocItem_checkIcon__8Q7zk","documentInfo":"SignDocItem_documentInfo__anqaH"};